<template>
    <v-card class="panelBlock add-owner" v-if="isOwnerDialogOpen" v-model="isOwnerDialogOpen">
        <h3> {{displayOwnerTitle()}}
            <i class="far fa-times-circle" @click="closeOwnerDialog()" data-qe-id="ownerOperatorclose"></i>
        </h3>
        <v-layout row wrap class="add-owner__title" v-if="personAssetRelation.length === 0">
            <v-flex xs12 class="search-people">
                {{assetSummaryConstants.SEARCH_PROFILE}}
            </v-flex>
        </v-layout>
        <v-flex class="relative-position search-parent">
            <v-flex width="100%" v-if="personAssetRelation.length === 0">
                <v-text-field
                    placeholder="Search for people by name"
                    append-icon="search"
                    slot="activator"
                    single-line
                    small
                    outline
                    clearable
                    data-qe-id="ownerOperatorsearch"
                    v-model="peopleSearchText"
                    @keyup="getOwnerProfile()"
                    @click:clear="clearPeopleSearch()">
                </v-text-field>
            </v-flex>
            <v-flex class="add-owner__body inner-scrollbar search-result" v-if="isSearchMembers">
                <status-overlay :action="getOwnersAction"></status-overlay>
                <v-flex class="add-owner__body__list-item" v-for="(invitee,i) in ownerProfiles.searchResults" :key="i">
                    <v-avatar class="add-owner__body__list-item__avatar">
                        <img class="dialog-box__img-format" align-center
                        :src="invitee.profileImageUrl"
                        :onerror="imageErrorFallback(invitee.fallbackProfileImageUrl)">
                    </v-avatar>
                        <v-flex tag="strong" class="add-owner__body__list-item__name">{{preferredName(invitee)}}</v-flex>
                        <v-flex v-for="(chapter,i) in invitee.chapters" :key="i">
                            <v-flex tag="small" v-if="chapter.isPrimary">{{chapter.name}}</v-flex>
                        </v-flex>
                        <v-btn icon @click="addOwner(invitee)" :data-qe-id="`add-chapter_${i}_owner`">
                            <v-icon>fas fa-plus</v-icon>
                        </v-btn>
                </v-flex>
            </v-flex>
            <v-flex class="add-owner__body inner-scrollbar add-owner-result" v-if="personAssetRelation.length > 0">
                <v-flex class="add-owner__body__list-item">
                    <v-avatar class="add-owner__body__list-item__avatar">
                        <img class="dialog-box__img-format" align-center
                        :src="addedOwner.profileImageUrl"
                        :onerror="imageErrorFallback(addedOwner.fallbackProfileImageUrl)">
                    </v-avatar>
                    <v-flex tag="strong" class="add-owner__body__list-item__name">{{addedOwner.name}}</v-flex>
                    <v-btn icon v-if="!selectedOwner" @click="deleteOwner(addedOwner.id)" data-qe-id="ownerOperatorSearchRemove">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="owner-dropdown">
                    <v-flex tag="em">{{assetSummaryConstants.OWNER_RELATION_ASSET}} {{memberProfileConstants.ASTERISK}}
                    </v-flex>
                    <v-combobox
                        content-class="owner-checkbox-disabled"
                        color="ypo_blue"
                        :items="relationshipToAssetOptions"
                        v-model="addedOwner.relationshipsToAsset"
                        @change="onAssetRelationChange(addedOwner.relationshipsToAsset, relationshipToAssetOptions)"
                        required
                        attach
                        multiple
                        :rules="assetSummaryConstants.relationshipToAssetRules"
                        data-qe-id="additionalRelationshipDropdown">
                    </v-combobox>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex xs12 text-xs-right pa-3>
            <status-bar :action="addOwnerAction"></status-bar>
            <v-btn
                class="primary_btn transparent small"
                small
                data-qe-id="ownerOperatorcancel"
                @click="closeOwnerDialog()">{{appCommonConstants.CANCEL}}</v-btn>
            <v-btn
                v-if="!selectedOwner"
                class="primary_btn small"
                small
                data-qe-id="ownerOperatorsave"
                @click="addMemberToAsset()"
                :disabled="isAddButtonDisabled()">{{appCommonConstants.ADD}}</v-btn>
            <v-btn
                v-if="selectedOwner"
                class="primary_btn small"
                small
                data-qe-id="editownerOperator"
                @click="editOwner()"
                :disabled="isAddButtonDisabled()">{{appCommonConstants.DONE}}</v-btn>
        </v-flex>
    </v-card>
</template>
<script>
import { memberProfileConstants, assetSummaryConstants, onAssetRelationChange } from "../memberProfile.constants";
import { appCommonConstants } from "../../appCommon.constants.js";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import { storeGetters } from "../../../store/storeGetters.constant";
import { storeMutation } from '../../../store/storeMutations.constant';
import StatusOverlay from '../../StatusOverlay/StatusOverlay';
import StatusBar from "../../StatusBar/StatusBar";
import { imageErrorFallback } from "../../../common/utils/utils";
import Vue from 'vue';

export default {
        name: 'AssetOwnerDialog',
        components: {
            StatusOverlay,
            StatusBar,
        },
        data: () => ({
            memberProfileConstants,
            assetSummaryConstants,
            appCommonConstants,
            peopleSearchText: '',
            isSearchMembers: false,
            addedOwner: {},
            record: [],
            personAssetRelation: [],
            disableAddButton: false,
            relationshipToAssetOptions: [],
        }),
        props: {
            value: {
                type: Boolean,      
            },
            assetData: {
                type: Object,
            },
            selectedOwner: {
                type: Object,
            },
        },
        created() {        
            this.record = Vue.util.extend({}, this.assetData);
            this.relationshipToAssetOptions = Vue.util.extend([], assetSummaryConstants.relationshipToAsset);
            if (this.selectedOwner) {
                this.addedOwner = Vue.util.extend({}, this.selectedOwner);
                this.personAssetRelation.push(this.addedOwner);
                this.onAssetRelationChange(this.addedOwner.relationshipsToAsset, this.relationshipToAssetOptions);
            } else {
                this.relationshipToAssetOptions.forEach((item) => {
                    item.disabled = false;
                });
            }
        },
        methods: {
            ...mapActions({
                getSearchProfile: `memberProfile/${storeAction.getSearchProfile}`,
                checkPersonAssetMappingExists: `memberProfile/${storeAction.checkPersonAssetMappingExists}`,
            }),
            ...mapMutations({
                setOwnerProfiles: `memberProfile/${storeMutation.setSearchProfile}`,
            }),
            imageErrorFallback,
            onAssetRelationChange,
            getOwnerProfile() {
                if (this.peopleSearchText && this.peopleSearchText.length < 3) {
                    this.ownerProfiles.searchResults = null;
                    this.isSearchMembers = false;
                }
                clearTimeout(this.timeoutForTypeAhead);
                this.timeoutForTypeAhead = setTimeout(() => {
                    if (this.peopleSearchText.length > 2) {
                        const requestbody = {
                            search: this.peopleSearchText,
                            orderBy: "LastName asc",
                            searchFilters: [],
                            skip: 0,
                        };
                        this.getSearchProfile(requestbody);
                        this.isSearchMembers = true;
                    } else if (!this.peopleSearchText) {
                        this.clearPeopleSearch();
                    }
                }, 1500);
            },
            preferredName(invitee) {
                let name = null;
                if (invitee.preferredName) {
                    name = `${invitee.preferredName} ${invitee.lastName}`;
                } else {
                    name = `${invitee.firstName} ${invitee.lastName}`;
                }
                return name;
            },
            clearPeopleSearch() {
                this.ownerProfiles.searchResults = null;
                this.isSearchMembers = false;
                this.peopleSearchText = '';
                this.disableAddButton = false;
            },
            closeOwnerDialog() {
                this.setOwnerProfiles([]);
                this.isOwnerDialogOpen = false;
                this.peopleSearchText = '';
                this.addedOwner = {};
                this.personAssetRelation = [];
            },
            addOwner(objInvitee) {
                const person = {
                    personId: objInvitee.id,
                    fallbackProfileImageUrl: objInvitee.fallbackProfileImageUrl,
                    gender: objInvitee.gender,
                    name: this.preferredName(objInvitee),
                    profileImageUrl: objInvitee.profileImageUrl,
                    relationshipsToAsset: [],
                };
                if (this.record.id) {
                    person.assetId = this.record.id;
                }

                this.personAssetRelation.push(person);
                this.addedOwner = person;
                this.clearPeopleSearch();
            },
            deleteOwner() {
                this.addedOwner = {};
                this.personAssetRelation = [];
            },
            addMemberToAsset() {
                if (this.personAssetRelation.length > 0) {
                    this.record.personAssetRelation = this.personAssetRelation;
                    this.checkPersonAssetMappingExists(this.record).then((res) => {
                        if (res.data === true) {
                            this.$emit('showAssetMappingExist', true);
                            this.disableAddButton = true;
                        } else {
                            this.editOwner();
                        }
                    });
                }
            },
            isAddButtonDisabled() {
                return this.personAssetRelation.length === 0 || (this.addedOwner && this.addedOwner.relationshipsToAsset.length === 0) || this.disableAddButton;
            },
            displayOwnerTitle() {
                return this.selectedOwner ? this.assetSummaryConstants.EDIT_OWNER : this.assetSummaryConstants.ADD_OWNER;
            },
            editOwner() {
                this.$emit('personAssetRelation', this.addedOwner);
                this.closeOwnerDialog();
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            addOwnerAction() {
                return this.actions[storeAction.checkPersonAssetMappingExists];
            },
            ...mapGetters({
                ownerProfiles: `memberProfile/${storeGetters.searchProfile}`,
            }),
            getOwnersAction() {
                return this.actions[storeAction.getSearchProfile];
            },
            isOwnerDialogOpen: {
                get() {
                    return this.value;
                },
                set(value) {
                    if (typeof (value) === "boolean") {
                        this.$emit('input', value);
                    }
                },
            },
        },
    };
</script>
<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_responsive.scss";

    .add-owner {
        border: 0 !important;
        z-index: 1;
        position: absolute;
        left: 40px;
        top: 35px;
        width: 100%;

        h3 {
            color: $white;
            background: $ypo_blue;
            font-size: 14px;
            padding: 10px 15px;
            letter-spacing: 0;
            font-weight: 500;
            position: relative;

            i{
                position: absolute;
                right: 10px;
                cursor: pointer;
            }
        }

        &__title {
            padding: 10px 5px 5px 15px;
            border-bottom: 1px solid $ypo-medium-gray;
            margin-bottom: 10px;
            font-size: 14px;
            text-transform: uppercase;
            color: rgba($ypo_blue, 0.61);
            align-items: center;
            font-weight: 600;

            .v-btn {
                margin: 0 -5px 0 0px;
            }
        }

        &__body {
            max-height: 350px;
            padding: 15px;
            overflow-y: auto;

            &__list-item {
                position: relative;
                padding: 20px 10px 20px 75px;
                border-bottom: 1px $ypo-medium-gray solid;
                align-items: center;
                min-height: 80px;

                &:hover {
                    background: $ypo-open-blue-gray;

                    .v-btn {
                        opacity: 1;
                        visibility: visible;
                    }
                }

                &__avatar {
                    position: absolute;
                    left: 10px;
                    top: 16px;
                }

                &__name {
                    font-size: 15px;
                    color: $ypo-dark-background-gray;
                    font-weight: 600;
                    display: block;
                }

                small {
                    display: block;
                    color: $ypo-dark-background-gray;
                }

                .v-btn {
                    position: absolute;
                    right: -6px;
                    z-index: 2;
                    top: 16px;
                    opacity: 0;
                    visibility: hidden;
                    transition: 0.5s all ease;

                    .v-icon {
                        color: $ypo_blue !important;
                        font-size: 20px;
                    }
                }
            }

            &.add-owner-result {
                padding-top: 0;

                .owner-dropdown{
                    em {
                        display: inline-block;
                        font-size: 14px;
                        padding-top: 14px;
                        font-style: inherit;
                        color: $ypo-blue;
                    }
                }
            }

            &.search-result {
                width: 100%;
                background: $white;
                z-index: 1;
                border: 1px $ypo-medium-gray solid;
                border-radius: 0px 0px 3px 3px;
                box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                border: 1px solid rgba($ypo-gray, 0.4) !important;
                padding: 0 15px;
                margin-top: -28px;
                margin-bottom: 10px;
            }
        }

        .search-parent {
            margin: 15px 15px 0 15px;
        }

        .search-people {
            display: block;
            padding: 5px 10px;

            span {
                font-size: 12px;
                text-transform: capitalize;
                color: $ypo-dark-background-gray;
                font-weight: 500;
                padding: 3px 0 0 22px;
            }
        }

        .search-parent {
            small {
                font-size: 12px;
            }
        }
    }
</style>
<style lang="scss">
    @import "../../../common/styles/_colors.scss";

    .asset_owner{
        .add-owner {
            .v-input__slot {
                min-height: inherit;
                margin-bottom: 8px;
                border: 1px solid $ypo-gray-text !important;
                input {
                    margin-top: 4px;
                    font-size: 12px;
                }
                .v-input__append-inner {
                    margin-top: 8px;
                    .v-icon {
                        font-size: 20px;
                    }
                }
            }
            &__body {
                &.add-owner-result {
                    .owner-dropdown {
                        .v-text-field {
                            padding: 0px;
                            margin: 0px;
                            font-size: 14px;
                        }
                        .v-input__slot {
                            border: none !important;
                        }
                    }
                }
            }
        }
    }
    .owner-checkbox-disabled {
        .v-input__slot {
            margin-bottom: 0 !important;
        }
        .theme--light.v-icon {
            color: inherit !important;
        }
    }
</style>
